import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';

import { PrivateRoute } from 'src/router';
import { ClientListController } from './clients/list/client-list.controller';
import { ClientFormController } from './clients/form/client-form.controller';
import * as Permissions from "../permissions";

export class CrmController extends React.Component<RouteComponentProps<any>, any> {
	render() {
		const match = this.props.match;
		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/clients/:id`}
					component={ClientFormController}
					{...this.props}
					permissions={Permissions.clientWritePermissions}
				/>
				<PrivateRoute
					path={`${match.url}/clients`}
					component={ClientListController}
					{...this.props}
					permissions={Permissions.clientPermissions}
				/>
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/crm.controller.tsx